module.exports = __webpack_public_path__ + "static/media/slider-9.4c96c1cc.jpg";